export default (e: any) => {
  return e?.response?._data?.errors || {};
};
